import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '../../ui/table';

/**
 * Where the judge's table turns from the people still to climb to the ones
 * who are done with the block — a top, or a card on a route — and have been
 * sunk to the bottom (arrangeParticipants). A hairline in the text's own
 * colour, with its label inverted on it, so it reads as a line drawn across the
 * list rather than as one more row of it.
 */
export function JudgeDoneDivider() {
  const { t } = useTranslation();

  return (
    <TableRow className="border-0 hover:bg-transparent" data-testid="done-divider">
      <TableCell colSpan={3} className="px-0 py-1">
        <div className="flex items-center" role="separator">
          <span className="rounded-sm bg-foreground px-1.5 text-[10px] font-semibold uppercase leading-4 tracking-wide text-background">
            {t('judgeBlock.doneDivider')}
          </span>
          <span className="h-px flex-1 bg-foreground" aria-hidden />
        </div>
      </TableCell>
    </TableRow>
  );
}
